import React, { useState, useEffect, useContext } from 'react';
import ClientApiService from "../../controller/ClientApiController/ClientApiController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateClientApi from './CreateClientApi';
import BASE_URL from "../../../../config/config";
import HelpSite from "../../../Common/HelpLink";
import Common from '../../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
function ClientApiPage() {
    const navigate = useNavigate();
    const [ClientApiList, setClientApiList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [currentClientApi, setcurrentClientApi] = useState(null);

    const fetchClientApi = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await ClientApiService.GetAll();
            setClientApiList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        fetchClientApi();
    }, []);

    const handleCreateClick = () => {
        setcurrentClientApi(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (data) => {
        setcurrentClientApi(data); // Set the team to be edited
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation();
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await ClientApiService.Delete(ID);
                    fetchClientApi();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const CompanyID = localStorage.getItem("CompanyID");
    return (
        <div>
            <Common />
            <div className="row mb-3">

                <div className="col-sm-3">

                    <Link className='btn btn-primary btn-sm' onClick={handleCreateClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th>Company Name</th>
                        <th>Api Name</th>
                        <th>URL</th>
                        
                        <th>Company Code</th>
                        <th>Supplier Code</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>IntervalMinutes</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead><tbody>
                    {ClientApiList.map((issue, index) => (

                        <tr key={issue.ID} onClick={() => handleEditClick(issue)}
                            style={{
                                cursor: 'pointer',
                            }}>
                            <td>{issue.CompanyName}</td>
                            <td>{issue.APIName}</td>
                            <td>{issue.BaseURL}</td>
                          
                            <td>{issue.CompanyCode}</td>
                            <td>{issue.SupplierCode}</td>
                            <td>{issue.FromDate}</td>
                            <td>{issue.Todate}</td>
                            <td>{issue.IntervalMinutes}</td>
                            <td style={{ "textAlign": "right" }}>

                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleDeleteClick(event, issue.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {(isModalOpen &&
                <CreateClientApi ClientApi={currentClientApi} onClose={handleCloseModal} onSuccess={fetchClientApi} />
            )}
        </div>
    );
}

export default ClientApiPage;